import { createStyles, rem } from "@mantine/core";
import { rgba } from "polished";

export const useStyles = createStyles((theme) => ({
  documentInfo: {
    padding: rem(16),
    backgroundColor: rgba(theme.colors.dusk[0], 0.1),
    borderRadius: rem(8),
    border: `1px solid ${theme.colors.dusk[0]}`,
    width: "100%",
    marginTop: rem(8),
  },
}));
